if (typeof window !== 'undefined') {
  const cryptoObj = window.crypto;
  const target = (window.Crypto && window.Crypto.prototype) ? window.Crypto.prototype : cryptoObj;

  if (!cryptoObj) {
    window.crypto = {};
  }

  if (target && typeof target.randomUUID !== 'function') {
    Object.defineProperty(target, 'randomUUID', {
      value: function randomUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
          const rand = Math.random() * 16 | 0;
          const value = char === 'x' ? rand : (rand & 0x3) | 0x8;
          return value.toString(16);
        });
      },
      configurable: true,
      writable: true
    });
  } else if (window.crypto && typeof window.crypto.randomUUID !== 'function') {
    Object.defineProperty(window.crypto, 'randomUUID', {
      value: function randomUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
          const rand = Math.random() * 16 | 0;
          const value = char === 'x' ? rand : (rand & 0x3) | 0x8;
          return value.toString(16);
        });
      },
      configurable: true,
      writable: true
    });
  }
}
